// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"49f4cfc2","117":"49f4cfc2"}[chunkId] + ".chunk.css";
};